import { tns } from "tiny-slider";

document.addEventListener("DOMContentLoaded", function () {
  const track = document.getElementById("gallery-mobile-track");
  const counter = document.getElementById("gallery-counter");
  const current = document.getElementById("gallery-counter-current");
  if (track && counter && current) {
    let ticking = false;
    track.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          const idx = Math.round(track.scrollLeft / (track.clientWidth || 1));
          current.textContent = String(idx + 1);
          counter.dataset.index = String(idx);
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  const shareBtn = document.getElementById("gallery-share-btn");
  const shareMenu = document.getElementById("gallery-share-menu");
  if (shareBtn) {
    const isMobile = () => window.matchMedia("(max-width: 767px)").matches;
    const setMenu = (open) => {
      if (!shareMenu) return;
      shareMenu.classList.toggle("hidden", !open);
      shareBtn.setAttribute("aria-expanded", String(open));
    };
    shareBtn.addEventListener("click", async (e) => {
      e.stopPropagation();
      if (isMobile() && navigator.share) {
        try {
          await navigator.share({
            title: shareBtn.dataset.shareTitle || document.title,
            url: window.location.href,
          });
        } catch (err) {
          // user cancelled share
        }
        return;
      }
      setMenu(shareMenu ? shareMenu.classList.contains("hidden") : false);
    });
    document.addEventListener("click", (e) => {
      if (shareMenu && !shareMenu.contains(e.target)) setMenu(false);
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") setMenu(false);
    });
  }

  const modal = document.getElementById("gallery-modal");
  if (!modal) return;
  let slider = null;
  let thumbSlider = null;
  // TinySlider-Instanz suchen
  function getSlider() {
    if (slider) return slider;
    if (tns && document.querySelector("#gallery-modal-slider")) {
      slider = tns({
        container: "#gallery-modal-slider",
        items: 1,
        gutter: 0,
        controls: false,
        controlsPosition: "bottom",
        nav: true,
        navContainer: "#gallery-modal-thumbs",
        navAsThumbnails: true,
        mouseDrag: true,
        loop: true,
        swipeAngle: false,
        speed: 400,
        arrowKeys: true,
        responsive: {
          768: {
            controls: true,
          },
        },
      });

      if (document.querySelector("#gallery-modal-thumbs")) {
        thumbSlider = tns({
          container: "#gallery-modal-thumbs",
          fixedWidth: 60,
          gutter: 8,
          controls: false,
          nav: false,
          mouseDrag: true,
          loop: false,
          speed: 400,
          swipeAngle: false,
          autoWidth: false,
          responsive: {
            768: {
              fixedWidth: 96,
            },
          },
        });
        slider.events.on("indexChanged", (info) => {
          const idx = info.displayIndex - 1; // displayIndex ist 1-basiert
          thumbSlider.goTo(idx);
        });
      }
    }

    return slider;
  }

  window.openGalleryModal = function (idx) {
    modal.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
    // Slider initialisieren oder holen
    const s = getSlider();
    if (s && typeof s.goTo === "function") {
      s.goTo(idx);
    }
    setTimeout(() => {
      const sliderEl = document.querySelector("#gallery-modal-slider");
      if (sliderEl) sliderEl.focus();
    }, 100);
  };
  window.closeGalleryModal = function () {
    modal.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  };

  document.addEventListener("keydown", function (e) {
    if (!modal.classList.contains("hidden")) {
      if (e.key === "Escape") window.closeGalleryModal();
    }
  });
});
